var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "container-fluid landing-container text-center" },
      [
        _c("div", { staticClass: "dashboard-block" }, [
          _c("h1", [_vm._v("Welcome, " + _vm._s(_vm.$user.first_name) + "!")]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("p", { staticClass: "lead-text" }, [
              _vm._v(
                "You will be notified once the " +
                  _vm._s(_vm.clientName) +
                  " team has verified your profile and then you're good to go!"
              ),
              _c("br"),
              _c("br"),
              _vm._v(
                "While you wait download our " +
                  _vm._s(_vm.$starLabel) +
                  " app."
              ),
            ]),
            _vm._v(" "),
            _vm._m(0),
          ]),
        ]),
      ]
    ),
    _vm._v(" "),
    _vm.clientName === "Pickstar"
      ? _c("div", { staticClass: "container-fluid" }, [
          _c(
            "div",
            { staticClass: "content-list" },
            [
              _c("span", { staticClass: "lead-text" }, [
                _vm._v(
                  "Thanks for signing up with us here at " +
                    _vm._s(_vm.clientName) +
                    "! Here are some quick tips on how to get the best out of the " +
                    _vm._s(_vm.clientName) +
                    " platform:"
                ),
              ]),
              _vm._v(" "),
              _vm._l(_vm.content, function (item, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "content-list-item" },
                  [
                    _c("span", { staticClass: "content-list-item__heading" }, [
                      _vm._v(_vm._s(item.heading)),
                    ]),
                    _c("br"),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(item.text))]),
                  ]
                )
              }),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  "Remember you can always contact us if you have any questions!"
                ),
              ]),
            ],
            2
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "background-color-container text-center" }, [
      _c("div", { staticClass: "container-fluid landing-container" }, [
        _c("h2", { staticClass: "subheading" }, [
          _vm._v("How to use " + _vm._s(_vm.clientName)),
        ]),
        _vm._v(" "),
        _vm._m(1),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "container-fluid landing-container" }, [
      _c("div", { staticClass: "dashboard-block" }, [
        _c("h2", { staticClass: "text-center" }, [_vm._v("Our Hot Tips")]),
        _vm._v(" "),
        _vm._m(2),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "button-wrapper" },
          [
            _c(
              "router-link",
              {
                attrs: {
                  to: { name: "profile.show", params: { id: this.$user.id } },
                },
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-block btn-primary dropdown-toggle",
                    attrs: { type: "button" },
                  },
                  [_vm._v("\n            My Profile\n          ")]
                ),
              ]
            ),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "flex items-center justify-center" }, [
      _c(
        "a",
        {
          attrs: {
            href: "https://itunes.apple.com/au/app/pickstar-sports-talent/id1425719956?mt=8",
            target: "_blank",
          },
        },
        [
          _c("img", {
            staticStyle: { height: "40px", width: "auto", "max-width": "none" },
            attrs: {
              alt: "Download in App Store",
              src: "https://linkmaker.itunes.apple.com/en-us/badge-lrg.svg?releaseDate=2018-10-06&kind=iossoftware&bubble=ios_apps",
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          attrs: {
            href: "https://play.google.com/store/apps/details?id=pickstar.com.au.talent&hl=en_AU",
            target: "_blank",
          },
        },
        [
          _c("img", {
            staticStyle: { height: "60px", width: "auto", "max-width": "none" },
            attrs: {
              alt: "Get it on Google Play",
              src: "https://play.google.com/intl/en_us/badges/images/generic/en_badge_web_generic.png",
            },
          }),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "iframe-container" }, [
      _c("iframe", {
        attrs: {
          src: "https://www.youtube.com/embed/XcAPqMAJY0M",
          frameborder: "0",
          allow:
            "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
          allowfullscreen: "",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", { staticClass: "icon-list" }, [
      _c("li", [
        _c("div", { staticClass: "row display-table" }, [
          _c("div", { staticClass: "fa-stack fa-2x display-table" }, [
            _c("i", {
              staticClass: "fa fa-circle fa-stack-2x icon-background-primary",
            }),
            _vm._v(" "),
            _c("i", {
              staticClass: "fa fa-pencil fa-stack-1x icon-foreground",
            }),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v("Fill out your profile with as much detail as possible!"),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", { staticClass: "row display-table" }, [
          _c("div", { staticClass: "fa-stack fa-2x display-table" }, [
            _c("i", {
              staticClass: "fa fa-circle fa-stack-2x icon-background-primary",
            }),
            _vm._v(" "),
            _c("i", {
              staticClass: "fa fa-video-camera fa-stack-1x icon-foreground",
            }),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Add videos to your profile using the youtube embed function!"
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", { staticClass: "row display-table" }, [
          _c("div", { staticClass: "fa-stack fa-2x display-table" }, [
            _c("i", {
              staticClass: "fa fa-circle fa-stack-2x icon-background-primary",
            }),
            _vm._v(" "),
            _c("i", { staticClass: "fa fa-check fa-stack-1x icon-foreground" }),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "The more active you are, the better your chance of being booked!"
            ),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }